import { required, minLength, maxLength } from 'vuelidate/lib/validators'
export default {
  validations: {
    groupCk: {
      required
    },
    subGroupCk: {
      required
    },
    selectedPlan: {
      required
    },
    selectedClass: {
      required
    },
    zip: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(5)
    }
  },
  computed: {
    classError() {
      if (!this.$v.selectedClass.required) {
        return 'required'
      }
    },
    planError() {
      if (!this.$v.selectedPlan.required) {
        return 'required'
      }
    },
    zipError() {
      if (!this.$v.zip.required) {
        return 'required'
      } else if ((!this.$v.zip.minLength || !this.$v.zip.maxLength) && this.$v.zip.$dirty) {
        return 'must contain 5 numbers'
      } else {
        return ''
      }
    },
    disable() {
      if (!this.$v.$invalid) {
        return false
      } else {
        return true
      }
    },
    groupCkError() {
      if (!this.$v.groupCk.required) {
        return 'required'
      }
    },
    subGroupCkError() {
      if (!this.$v.subGroupCk.required) {
        return 'required'
      }
    }
  }
}
